import ChevronDownIcon from './chevron-down.svg'
import clsx from 'clsx'
import classes from './IntegrationLoadMoreButton.module.scss'

export const IntegrationLoadMoreButton = ({
  toggleButton,
  isActive,
  scrollAnchor,
  additionalItemsAmount,
  className,
}: {
  toggleButton: () => void
  isActive: boolean
  scrollAnchor: HTMLElement
  additionalItemsAmount: number
  className: string
}) => {
  const scrollToTop = (element: HTMLElement, isActive: boolean) => {
    if (isActive) {
      window.scrollTo({
        top: element.offsetTop,
        left: 0,
        behavior: 'smooth',
      })
    }
    toggleButton()
  }

  return (
    <div className={classes.button_wrap}>
      <button
        type={'button'}
        onClick={() => scrollToTop(scrollAnchor, isActive)}
        className={clsx(
          'link link--no-line-gradient',
          classes.button,
          className,
        )}
      >
        <span className='link__content'>
          {isActive
            ? 'Hide additional collections'
            : `Show ${additionalItemsAmount} more`}
        </span>
        <img
          src={ChevronDownIcon.src}
          alt='Icon'
          className={clsx(
            classes.button_icon,
            isActive && classes.button_icon__active,
          )}
        />
      </button>
    </div>
  )
}
